export function transparentColor(color: string, alpha: number): string {
  // If the color is a CSS variable (e.g., 'var(--color-primary)')
  // we can use CSS color-mix to apply opacity natively!
  if (color.startsWith('var(')) {
    // color-mix uses percentages (0 to 100)
    const percentage = alpha * 100;
    return `color-mix(in srgb, ${color} ${percentage}%, transparent)`;
  }

  // Regex to match both rgb() and rgba() string formats
  const rgbaRegex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+)?\s*\)$/i;
  const match = color.match(rgbaRegex);

  if (match) {
    const [, r, g, b] = match;
    // Replace the existing alpha (if any) with the new alpha
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Optional fallback for hex colors, in case they are used
  if (color.startsWith('#')) {
    let hex = color.replace('#', '');
    
    // Handle shorthand hex (e.g., #FFF)
    if (hex.length === 3) {
      hex = hex.split('').map((c) => c + c).join('');
    }
    
    if (hex.length === 6) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  // Return the original color if it doesn't match known formats
  return color;
}
